export default {"src":"/_next/static/media/water-games.5b18cf45.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};